import { g as d } from "../../utils-BOfnFgIH.js";
import { I as l } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as o, normalizeClass as s, createElementVNode as a } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconGlobe2",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(l).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = d();
  }
}, m = ["aria-label", "data-qa", "aria-hidden"], f = ["clip-path"], p = ["id"];
function h(e, t, r, _, v, i) {
  return n(), o("svg", {
    "aria-label": r.ariaLabel,
    class: s([i.iconSizeClass, "d-icon d-icon--globe-2"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Globe 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`
    }, [...t[0] || (t[0] = [
      a("path", {
        fill: "currentColor",
        "fill-rule": "evenodd",
        d: "M1.612 5H2.5A1.5 1.5 0 0 1 4 6.5V7a.5.5 0 0 0 .5.5A1.5 1.5 0 0 1 6 9v1.5c.344 0 .678-.039 1-.111V8.5A1.5 1.5 0 0 1 8.5 7h1.889a4.513 4.513 0 0 0-.145-2.5H9a.5.5 0 0 0-.5.5 1.5 1.5 0 0 1-3 0 .5.5 0 0 0-.49-.5 2 2 0 0 1-1.982-1.334A.5.5 0 0 1 3 3v-.354A4.497 4.497 0 0 0 1.612 5Zm2.387-3.032L4 2v.906A1 1 0 0 0 5 3.5 1.5 1.5 0 0 1 6.5 5a.5.5 0 0 0 1 0A1.5 1.5 0 0 1 9 3.5h.742A4.496 4.496 0 0 0 6 1.5c-.719 0-1.398.169-2.001.468ZM10.032 8H8.5a.5.5 0 0 0-.5.5v1.532A4.519 4.519 0 0 0 10.032 8Zm-4.417 3.487a5.5 5.5 0 1 0-.323-.032.5.5 0 0 0 .323.032ZM5 10.389A4.502 4.502 0 0 1 1.5 6h1a.5.5 0 0 1 .5.5V7a1.5 1.5 0 0 0 1.5 1.5.5.5 0 0 1 .5.5v1.389Z",
        "clip-rule": "evenodd"
      }, null, -1)
    ])], 8, f),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, [...t[1] || (t[1] = [
        a("path", {
          fill: "#fff",
          d: "M0 0h12v12H0z"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, m);
}
const q = /* @__PURE__ */ u(c, [["render", h]]);
export {
  q as default
};
//# sourceMappingURL=globe-2.js.map
